import React from "react";
import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
// UI
import { Button } from "@mantine/core";
// API
import { backendApi } from "@src/backendApi/backendApi";
import { queryClient } from "@config/tanstack/tanstackQuery";
import { useMutation } from "@tanstack/react-query";

const route = getRouteApi("/_authenticated/app");

export function LogoutButton(): React.ReactElement {
  const nav = route.useNavigate();
  const { t } = useTranslation();

  const { mutate, isPending } = useMutation({
    mutationKey: ["SESSION_LOGOUT"],
    mutationFn: async () => {
      const resp = await backendApi.sessionAuthLogout();
      return resp.data;
    },
    onSuccess: async () => {
      queryClient.clear();
      await nav({ to: "/login" });
    },
  });

  return (
    <Button
      variant="subtle"
      onClick={() => {
        mutate();
      }}
      loading={isPending}
    >
      {t("links.logOut")}
    </Button>
  );
}
